import { render, staticRenderFns } from "./TeamAvatar.vue?vue&type=template&id=5ed8dd42&scoped=true&"
import script from "./TeamAvatar.vue?vue&type=script&lang=js&"
export * from "./TeamAvatar.vue?vue&type=script&lang=js&"
import style0 from "./TeamAvatar.vue?vue&type=style&index=0&id=5ed8dd42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8dd42",
  null
  
)

export default component.exports